/**
 * TanStack Query hooks for `disallowed-traffic-channels-per-offer`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	disallowedTrafficChannelsPerOfferQueryKeys,
	type CreateDisallowedTrafficChannelsPerOfferBody,
	type ListDisallowedTrafficChannelsPerOfferResponse,
	type DisallowedTrafficChannelsPerOfferRow,
} from "./api";

export function useDisallowedTrafficChannelsPerOfferList(): UseQueryResult<ListDisallowedTrafficChannelsPerOfferResponse, Error> {
	return useQuery({
		queryKey: disallowedTrafficChannelsPerOfferQueryKeys.list(),
		queryFn: list,
	});
}

export function useDisallowedTrafficChannelsPerOfferCreate(): UseMutationResult<DisallowedTrafficChannelsPerOfferRow, Error, CreateDisallowedTrafficChannelsPerOfferBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: disallowedTrafficChannelsPerOfferQueryKeys.all });
		},
	});
}

export function useDisallowedTrafficChannelsPerOfferDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: disallowedTrafficChannelsPerOfferQueryKeys.all });
		},
	});
}
